import script from "./ProductTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTable.vue?vue&type=script&setup=true&lang=js"

import "./ProductTable.vue?vue&type=style&index=0&id=8a418f84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a418f84"]])

export default __exports__